import React from 'react';

import Classes from './Skeleton.module.scss';

import SkeletonBase from './SkeletonBase';

type TProps = {
  withAnimation?: boolean;
};

const TextSkeleton = ({ withAnimation }: TProps) => (
  <SkeletonBase as="span" className={Classes.ButtonSkeleton} withAnimation={withAnimation} />
);

export default TextSkeleton;
